import Vue from "vue";
import Router from "vue-router";
import { api } from "@/state/services";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      component: () => import("./views/dashboards/main"),
      meta: { authRequired: true },
    },
    {
      path: "/dashboards",
      component: () => import("./views/dashboards/main"),
      meta: { authRequired: true },
    },
    {
      path: "/login",
      component: () => import("./views/login"),
      meta: { authRequired: false },
    },
    {
      path: "/login/token/:token",
      component: () => import("./views/login-in"),
      meta: { authRequired: false },
    },
    {
      path: "/logout",
      redirect: "/login",
    },
    {
      path: "/register",
      component: () => import("./views/register"),
      meta: { authRequired: false },
    },
    {
      path: "/register/:sponsor",
      component: () => import("./views/register"),
      meta: { authRequired: false },
    },
    {
      path: "/password-forgot",
      component: () => import("./views/password-forgot"),
      meta: { authRequired: false },
    },
    {
      path: "/password-change",
      component: () => import("./views/password-change"),
      meta: { authRequired: false },
    },
    {
      path: "/account",
      component: () => import("./views/account/account"),
      meta: { authRequired: true },
    },
    {
      path: "/account/documents",
      component: () => import("./views/account/documents"),
      meta: { authRequired: true },
    },
    {
      path: "/account/address",
      component: () => import("./views/account/address"),
      meta: { authRequired: true },
    },
    {
      path: "/account/password",
      component: () => import("./views/account/password"),
      meta: { authRequired: true },
    },
    {
      path: "/account/password/security",
      component: () => import("./views/account/password-security"),
      meta: { authRequired: true },
    },
    {
      path: "/account/password/security/:token",
      component: () => import("./views/account/password-security"),
      meta: { authRequired: true },
    },
    {
      path: "/account/pix",
      component: () => import("./views/account/pix"),
      meta: { authRequired: true },
    },
    {
      path: "/contracts",
      component: () => import("./views/contracts/list"),
      meta: { authRequired: true },
    },
    {
      path: "/contracts/:id",
      component: () => import("./views/contracts/view"),
      meta: { authRequired: true },
    },
    {
      path: "/wallet/extract",
      component: () => import("./views/wallet/extract"),
      meta: { authRequired: true },
    },
    {
      path: "/wallet/transfer",
      component: () => import("./views/wallet/transfer"),
      meta: { authRequired: true },
    },
    {
      path: "/wallet/pay",
      component: () => import("./views/wallet/pay"),
      meta: { authRequired: true },
    },
    {
      path: "/wallet/pay/:id",
      component: () => import("./views/wallet/pay"),
      meta: { authRequired: true },
    },
    {
      path: "/wallet/withdrawal",
      component: () => import("./views/wallet/withdrawal"),
      meta: { authRequired: true },
    },
    {
      path: "/wallet/withdrawal/history",
      component: () => import("./views/wallet/withdrawal-history"),
      meta: { authRequired: true },
    },
    {
      path: "/network/clients",
      component: () => import("./views/network/clients"),
      meta: { authRequired: true },
    },
    {
      path: "/network/sponsored",
      component: () => import("./views/network/sponsored"),
      meta: { authRequired: true },
    },
    {
      path: "/network/team",
      component: () => import("./views/network/team"),
      meta: { authRequired: true },
    },
    {
      path: "/network/team/:id",
      component: () => import("./views/network/team"),
      meta: { authRequired: true },
    },
    {
      path: "/network/matriz",
      component: () => import("./views/network/matriz"),
      meta: { authRequired: true },
    },
    {
      path: "/network/unilevel",
      component: () => import("./views/network/unilevel"),
      meta: { authRequired: true },
    },
    {
      path: "/network/unilevel/:id",
      component: () => import("./views/network/unilevel"),
      meta: { authRequired: true },
    },
    {
      path: "/reports/indicacao",
      component: () => import("./views/reports/indicacao"),
      meta: { authRequired: true },
    },
    {
      path: "/reports/comissoes",
      component: () => import("./views/reports/comissoes"),
      meta: { authRequired: true },
    },
    {
      path: "/reports/graduation",
      component: () => import("./views/reports/graduation"),
      meta: { authRequired: true },
    },
    {
      path: "/downloads",
      component: () => import("./views/downloads"),
      meta: { authRequired: true },
    },
    {
      path: "/faq",
      component: () => import("./views/faq"),
      meta: { authRequired: true },
    },
    {
      path: "/tickets",
      component: () => import("./views/tickets"),
      meta: { authRequired: true },
    },
    {
      path: "/tickets/:id",
      component: () => import("./views/tickets-view"),
      meta: { authRequired: true },
    },
    {
      path: "/courses",
      component: () => import("./views/courses/list"),
      meta: { authRequired: true },
    },
    {
      path: "/courses/:course",
      component: () => import("./views/courses/view"),
      meta: { authRequired: true },
    },
    {
      path: "/courses/:course/:module/:lesson",
      component: () => import("./views/courses/view"),
      meta: { authRequired: true },
    },
    {
      path: "/polls",
      component: () => import("./views/polls/index"),
      meta: { authRequired: true },
    },
    {
      path: "/polls/:id",
      component: () => import("./views/polls/view"),
      meta: { authRequired: true },
    },
    {
      path: "/informatives",
      component: () => import("./views/informatives/index"),
      meta: { authRequired: true },
    },
    {
      path: "/informatives/:id",
      component: () => import("./views/informatives/view"),
      meta: { authRequired: true },
    },
    {
      path: "/events",
      component: () => import("./views/events/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/events/orders",
      component: () => import("./views/events/orders-list"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/events/orders/:id",
      component: () => import("./views/events/orders-view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/events/tickets",
      component: () => import("./views/events/tickets"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/events/:id",
      component: () => import("./views/events/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/subscriptions",
      component: () => import("./views/_subscriptions/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/subscriptions/:id",
      component: () => import("./views/_subscriptions/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/packages",
      component: () => import("./views/_packages/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/packages/buy",
      component: () => import("./views/_packages/buy"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/packages/:id",
      component: () => import("./views/_packages/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/limpanome",
      component: () => import("./views/_limpanome/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/limpanome/processos",
      component: () => import("./views/_limpanome/processos"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/limpanome/aprovados",
      component: () => import("./views/_limpanome/aprovados"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/limpanome/importacoes",
      component: () => import("./views/_limpanome/importacoes"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/limpanome/importacoes/:id",
      component: () => import("./views/_limpanome/importacao"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/exclusaoindividual",
      component: () => import("./views/_exclusaoindividual/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/exclusaoindividual/processos",
      component: () => import("./views/_exclusaoindividual/processos"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/exclusaoindividual/aprovados",
      component: () => import("./views/_exclusaoindividual/aprovados"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/exclusaoindividual/importacoes",
      component: () => import("./views/_exclusaoindividual/importacoes"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/exclusaoindividual/importacoes/:id",
      component: () => import("./views/_exclusaoindividual/importacao"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/jusbrasil",
      component: () => import("./views/_jusbrasil/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/jusbrasil/processos",
      component: () => import("./views/_jusbrasil/processos"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/jusbrasil/aprovados",
      component: () => import("./views/_jusbrasil/aprovados"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/jusbrasil/importacoes",
      component: () => import("./views/_jusbrasil/importacoes"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/jusbrasil/importacoes/:id",
      component: () => import("./views/_jusbrasil/importacao"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/webpush",
      component: () => import("./views/webpush"),
      meta: { authRequired: true },
    },
    {
      path: "/bacen",
      component: () => import("./views/_bacen/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/consultas",
      component: () => import("./views/_consultas/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/consultas/nova",
      component: () => import("./views/_consultas/nova"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/consultas/comprar",
      component: () => import("./views/_consultas/buy"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/consultas/pedidos/:id",
      component: () => import("./views/_consultas/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/consultas/pedidos",
      component: () => import("./views/_consultas/orders"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/consultas/:id",
      component: () => import("./views/_consultas/result"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/404",
      component: () => import("./views/404"),
      meta: { authRequired: false },
    },
    {
      path: "/:sponsor",
      redirect: "/register/:sponsor",
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("token");

  document.title = process.env.VUE_APP_TITLE;
  next();

  if (to.meta.authRequired && !loggedIn) {
    return next("/login");
  }

  if (to.meta.authRequired && loggedIn) {
    api
      .get("user")
      .then((response) => {
        if (response.data && response.data.status == "success") {
          router.app.$store.state.account.user = response.data.user;

          if (
            response.data.user.contracts &&
            response.data.user.contracts.length > 0 &&
            to.path != "/contracts/:id"
          ) {
            response.data.user.contracts.forEach(con => {
              return next("/contracts/" + con.id);
            })
          } else if (
            response.data.user.subscriptions &&
            response.data.user.subscriptions.check == 'active' &&
            response.data.user.subscriptions.status != "active" &&
            !to.path.startsWith("/subscriptions")) {
            return next("/subscriptions");
          } else {
            next();
          }
        } else {
          return next("/login");
        }
      })
      .catch(error => {
        if (error) {
          return next("/login");
        }
      });
  } else {
    next();
  }
});

export default router;
